import React, { useState, useEffect } from "react";
import * as trainingApi from "../../../api/trainingApi";
import { toast } from "react-toastify";
import { TrainingsForm } from "../../forms/Master/TrainingsForm";
import PropTypes from "prop-types";
import { showDeleteConfirm } from "../../common/ConfirmationModal";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export default function TrainingsPage({ history }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [trainings, setTrainings] = useState([]);
  const [rowSelected, setRowSelected] = useState({});
  const location = useLocation();
  let defaultPagination = location.state
    ? location.state.currentPage
      ? location.state.currentPage
      : 1
    : 1;
  const [currentPage, setCurrentPage] = useState(defaultPagination);

  useEffect(getTrainings, []);

  function getTrainings() {
    trainingApi
      .getAllTrainings()
      .then((result) => {
        setIsLoading(false);
        setTrainings(result);
      })
      .catch((error) => {
        setIsLoading(false);
        setTrainings([]);
        showErrorMessage(t("general.fail_to_load_record") + error.message);
      });
  }

  function addNewItem() {
    history("/home/trainings/training", {
      state: { currentPage: currentPage },
    });
  }

  function editItem(trainingKey) {
    history("/home/trainings/training/" + trainingKey, {
      state: { 
        fromSetup: true,
        currentPage: currentPage 
      },
    });
  }

  function onDelete(trainingKey) {
    showDeleteConfirm("Training", trainingKey, deleteTraining, t);
  }

  function deleteTraining(trainingKey) {
    setIsLoading(true);
    trainingApi
      .deleteTraining(trainingKey)
      .then(() => {
        const newData = trainings.filter(
          (item) => item.TrainingKey !== trainingKey
        );
        setTrainings(newData);
        setIsLoading(false);
        toast.success(t("general.record_deleted_successfully"));
      })
      .catch((error) => {
        setIsLoading(false);
        showErrorMessage(t("general.fail_to_delete_record") + error.message);
      });
  }

  function showErrorMessage(message) {
    toast.error(message);
  }

  function onRowSelected(value) {
    if (value.UpdatedDate) {
      value.UpdatedOn = value.UpdatedDate;
    }
    if (value.CreatedDate) {
      value.CreatedOn = value.CreatedDate;
    }
    setRowSelected(value);
  }

  return (
    <TrainingsForm
      isLoading={isLoading}
      trainings={trainings}
      onAdd={addNewItem}
      onEdit={editItem}
      onDelete={onDelete}
      onRowSelected={onRowSelected}
      rowSelected={rowSelected}
      setCurrentPage={setCurrentPage}
      currentPage={currentPage}
    />
  );
}

TrainingsPage.propTypes = {
  history: PropTypes.func.isRequired,
};
